export default __webpack_public_path__ + "static/Dekra_LP2_Hero-41f5c67c6cba8901ec4fcc77891e8b83.png";